module.exports = __webpack_public_path__ + "static/media/USDHS-FEMA.1e1fc7b1.jpg";